import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webapp/cinehub/webapp/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webapp/cinehub/webapp/src/app/[locale]/ClientBrowse.tsx");
